<template style="height: 100%;">
  <div class="CommonContentSingle-gray">
    <el-container>
      <el-header>
        <el-form :inline="true" :model="from" class="demo-form-inline">
          <el-form-item label="人员搜索">
            <el-input v-model="group" placeholder="请输入要搜索的内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chaxun">查询</el-button>
            <el-button type="primary" @click="chaxuns">个人档案</el-button>
            <el-button type="primary" @click="danganliebiao">档案列表</el-button>
            <el-button type="primary" @click="danganliebiao2">大数据</el-button>
            <el-button type="primary" @click="danganliebiao3">认知训练</el-button>
            <el-button type="primary" @click="danganliebiao4">重大事件</el-button>
          </el-form-item>
        </el-form>
      </el-header>

      <el-main>

        <el-table ref="multipleTable" v-loading="wloadings" :data="tableData" style="width: 100%; margin-top: 10px;"
          :default-sort="{ prop: 'date', order: 'descending' }" @selection-change="handleSelectionChange">
          <el-table-column type="selection" min-width="20px" align="center"></el-table-column>
          <el-table-column label="序号" min-width="20px" align="left">
            <template slot-scope="scope" center>
              {{ (pageIndexs - 1) * 10 + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column label="内容">
            <template slot-scope="scope">
              <span>{{ scope.row.DropKeyContent }}</span>
            </template>
          </el-table-column>

          <el-table-column label="排序" min-width="20px">
            <template slot-scope="scope">
              <span>{{ scope.row.DropKeyLineNum }}</span>
            </template>
          </el-table-column>

          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.CreatedTimeShow }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="shenhe(scope.row.DropKeyID)">通过</el-button>
              <el-button size="mini" type="primary" @click="jujue(scope.row.DropKeyID)">驳回</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      group: '',
      wloadings: true,
      tableData: [],
      pageIndexs: 1,
      from: {
        DropKeyType: '',
        DropKeyContent: '',
        DropKeyLineNum: '',
      },
    }
  },
  components: {

  },
  methods: {
    shenhe(val) {
    },
    jujue(val) {
    },
    chaxun() {//查询

    },
    chaxuns() {
      this.$router.push('/Archives_management/Personal_file');
    },
    danganliebiao() {
      this.$router.push('/Archives_management/File_list');
    },
    danganliebiao2() {
      this.$router.push('/Data/All_data');
    },
    danganliebiao3() {
      this.$router.push('/training/Training_all');
    },
    danganliebiao4() {
      this.$router.push('/Crisis/Crisis_major_event');
    },
    handleSelectionChange(val) {
      this.multipleSelection = [];
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          this.multipleSelection.push(val[i].DropKeyID);
        }
      }
    },
    loading() {
      var dataForm = {
        pageSize: 10,
        pageIndex: 0,
        DropKeyType: "WorkGroup",
      };
      this.$Http_Post('workingtime/getdropdownkeylist', dataForm).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.wloadings = false;
          this.tableData = res.Data;
          this.totalnumber = res.Counts;
        } else {
          this.wloadings = false;
        }
      },)
    },
  },
  watch: {
  },
  mounted() {
    this.loading();
  }
}
</script>
<style>

.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
</style>